/** De volgorde waarin de vinkjes overal staan: het venster, de badge, de
 *  rechtentabel. Van wat je met gesprekken doet naar wat je beheert, met View
 *  Only als laatste omdat die niets toevoegt. */
export const RECHTENSOORTEN = ['buddy', 'coreTeam', 'admin', 'viewOnly'];
/** Wie niets mag. Bestaat als constante omdat een nieuwe persoon hier standaard
 *  op staat en een leeg object twee keer uitschrijven een plek is om er één te
 *  vergeten. */
export const GEEN_RECHTEN = {
    buddy: false,
    coreTeam: false,
    admin: false,
    viewOnly: false,
};
/** Alleen dit vinkje aan. Voor de rechtentabel op het scherm, die per soort wil
 *  weten wat hij oplevert. */
export function alleen(soort) {
    return { ...GEEN_RECHTEN, [soort]: true };
}
/**
 * Eén vinkje omzetten; de laatste klik wint. View Only aan zet de andere drie
 * uit, en elk ander vinkje zet View Only uit.
 *
 * Een functie en geen controle achteraf: een vinkje dat zichzelf meteen weer
 * uitzet leest als een kapot scherm.
 */
export function zetVinkje(waarde, soort, aan) {
    if (!aan)
        return { ...waarde, [soort]: false };
    if (soort === 'viewOnly')
        return alleen('viewOnly');
    return { ...waarde, [soort]: true, viewOnly: false };
}
/** Dezelfde uitsluiting, op een set die van buiten komt. */
export function normaliseerRechten(waarde) {
    if (waarde.buddy || waarde.coreTeam || waarde.admin)
        return { ...waarde, viewOnly: false };
    return waarde;
}
export const RECHTEN_LABEL = {
    buddy: 'Buddy',
    coreTeam: 'Core Team',
    admin: 'Admin',
    viewOnly: 'View Only',
};
export const RECHTEN_OMSCHRIJVING = {
    buddy: 'Levert gesprekken aan en beoordeelt de eigen transcripten en hulpvragen. Kan zijn eigen gecoachten aanmaken en koppelen. Verder uitsluitend de eigen gegevens.',
    coreTeam: 'De personen en de begeleiding van iedereen: toevoegen, uitnodigen, wijzigen, koppelen en archiveren. Komt niet bij de instellingen en de vaktermen. Wie Core Team of Admin wordt, blijft een keuze van de Admin.',
    admin: 'De cijfers, de personen, de vocabulaire en de instellingen. Levert zelf geen gesprekken aan en komt nooit bij het transcript van een ander.',
    viewOnly: 'Ziet de cijfers, de personen en de hulpvragen, en verandert niets. Levert geen gesprekken aan en begeleidt niemand.',
};
/**
 * Wat iemand is, in één regel.
 *
 * Bestaat omdat de badge meerdere tags kan tonen maar een regel tekst dat niet
 * kan: achter het label Rechten en in de koptekst hoort één antwoord te staan.
 * Opgebouwd uit de vinkjes die aanstaan, zodat er geen combinatie kan ontstaan
 * die hier niet is uitgeschreven. De labels houden hun hoofdletters, want het
 * zijn namen en geen functieomschrijvingen.
 */
export function rechtenTekst(rechten) {
    const woorden = RECHTENSOORTEN.filter((soort) => rechten[soort]).map((soort) => RECHTEN_LABEL[soort]);
    const laatste = woorden.pop();
    if (!laatste)
        return 'Geen';
    return woorden.length === 0 ? laatste : `${woorden.join(', ')} en ${laatste}`;
}
